const isFactory =
  (...expected) =>
  value =>
    expected.includes(value);

const isFactoryReversed = expected => value => value.includes(expected);

export { isFactory, isFactoryReversed };
